import React from "react";
import logoWce from "images/logo-wce.png";
import Circle from "components/Pattern/Circle";

const AuthLayout = ({ children }) => {
  return (
    <div className="bg-wce-pink-light py-8 md:py-24 px-6 md:px-8 w-full mx-auto">
      <div className="max-w-7xl flex flex-col md:flex-row items-center justify-between mx-auto gap-8 md:gap-[10%]">
        <div className="self-center w-[60%] md:w-1/2">
          <img className="w-full" src={logoWce} alt={"WCE Logo"} />
        </div>
        <div className="w-full md:w-[40%] z-10">{children}</div>
      </div>
      <Circle variant="one" />
    </div>
  );
};

export default AuthLayout;
